export default "__VITE_ASSET__BvRiI2RN__"